import { motion } from 'framer-motion';
import BlurFade from '../ui/BlurFade';
import { profile } from '../../data/profile';

const EMPHASIZE = [
  'LLMs', 'RAG pipelines', 'production AI', 'PyTorch', 'TensorFlow', 'Hugging Face',
  'Electrical Engineering', "'Chat with Krishna'", "'Chat with Docs'",
];

const emphasize = (text) => {
  const pattern = new RegExp(`(${EMPHASIZE.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'g');
  return text.split(pattern).map((part, i) =>
    EMPHASIZE.includes(part) ? (
      <strong key={i} className="font-black">{part}</strong>
    ) : (
      <span key={i}>{part}</span>
    )
  );
};

const About = () => {
  return (
    <section id="about" className="bg-black py-20 text-white">
      <div className="mx-auto flex max-w-4xl flex-col gap-10 px-6 md:flex-row md:items-center">
        <BlurFade className="mx-auto w-48 shrink-0 sm:w-60 md:mx-0">
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="overflow-hidden rounded-2xl border-2 border-white bg-white"
          >
            <img src="/images/about.png" alt={`${profile.name} portrait illustration`} className="w-full" />
          </motion.div>
        </BlurFade>

        <div>
          <BlurFade>
            <h2 className="mb-8 text-2xl font-black sm:text-3xl">
              About <span className="text-white/40">Me</span>
            </h2>
          </BlurFade>
          <div className="flex flex-col gap-4">
            {profile.bio.map((line, i) => (
              <BlurFade key={i} delay={i * 0.08}>
                <p className="text-lg leading-relaxed text-white/80 sm:text-xl">
                  {emphasize(line)}
                </p>
              </BlurFade>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
